import React from 'react';
import { SignificanceLevelIconInterface, StudyItemCardProps } from './types';
import style from './style.module.scss';
import cx from 'classnames';
import SegmentIllustration from '../../assets/segment_1.svg';
import PracticeCardIllustration1 from '../../assets/practice_card_1.svg';
import PracticeCardIllustration2 from '../../assets/practice_card_2.svg';
import PracticeCardIllustration3 from '../../assets/practice_card_3.svg';

import { DefaultButton, SecondaryButton } from '@magoosh/lib/button';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import Icon, { SectionIcons, SectionIllustrations } from '../../assets/icons';
import moment from 'moment';
import {
  HighSignificanceIcon,
  LowSignificanceIcon,
  ModerateSignificanceIcon
} from '@magoosh/gre/pages/mock_test_performance_summary/icons';
import { PremiumBadge } from '@magoosh/lib/info_badges';

export const StudyItemCard: React.FC<StudyItemCardProps> = (props) => {
  const {
    section,
    headline,
    subheadline,
    significanceLevel,
    minutes,
    date,
    percentageCompleted,
    description,
    shortDescription,
    primaryCTA,
    secondaryCTA,
    variant,
    isLarger,
    locked
  } = props;

  const SignificanceLevelIcon: SignificanceLevelIconInterface = {
    High: <HighSignificanceIcon style={{ fill: style.gray, height: '17px', width: '22px' }} />,
    Moderate: <ModerateSignificanceIcon style={{ fill: style.gray, height: '17px', width: '22px' }} />,
    Low: <LowSignificanceIcon style={{ fill: style.gray, height: '17px', width: '22px' }} />
  };

  const iconType: SectionIcons = {
    Math: 'Calc',
    Verbal: 'Notebook',
    Writing: 'Pen'
  };

  const illustrationType: SectionIllustrations = {
    Math: <img key="2" src={PracticeCardIllustration2} alt="Practice Card Illustration" />,
    Verbal: <img key="1" src={PracticeCardIllustration1} alt="Practice Card Illustration" />,
    Writing: <img key="3" src={PracticeCardIllustration3} alt="Practice Card Illustration" />
  };

  return (
    <div className={cx(style.studyItemCard, 'u-margin-B-l')}>
      <Row>
        <Col md={6}>
          <Icon
            iconType={iconType[section]}
            fill={variant === 'secondary' ? style.iconSecondary : style.brandInfo}
          />
        </Col>
        <Col md={6}>
          <div className={cx(style.buttonHeader, 'u-margin-B-m')}>
            {secondaryCTA && !locked && (
              <a className="u-margin-H-xs" style={{ color: style.grayDarker }} {...secondaryCTA}>
                {secondaryCTA.text}
              </a>
            )}

            {locked && <PremiumBadge className={'u-margin-H-xs'} />}

            {primaryCTA && primaryCTA.variant === 'secondary' && (
              <SecondaryButton disabled={primaryCTA.isDisabled} {...primaryCTA}>
                {primaryCTA.text}
              </SecondaryButton>
            )}

            {primaryCTA && primaryCTA.variant === 'default' && (
              <DefaultButton disabled={primaryCTA.isDisabled} {...primaryCTA}>
                {primaryCTA.text}
              </DefaultButton>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={isLarger ? 6 : 12}>
          <p className="u-margin-A-n" style={{ color: style.gray }}>
            {subheadline}
          </p>
          <h3 className="u-margin-A-n">{isLarger && description ? <strong>{headline}</strong> : headline}</h3>
          <p style={{ color: style.gray }}>
            {significanceLevel && (
              <span className="u-margin-R-xs">
                {SignificanceLevelIcon[significanceLevel]} {significanceLevel} Significance
              </span>
            )}

            {minutes && (
              <span className="u-margin-R-xs">
                <FontAwesomeIcon icon={'clock-o'} /> {minutes} min.
              </span>
            )}

            {date && (
              <span className="u-margin-R-xs">
                <FontAwesomeIcon icon={'calendar-check-o'} /> {moment(date).format('L')}{' '}
              </span>
            )}

            {percentageCompleted && (
              <span className="u-margin-R-xs">
                <FontAwesomeIcon icon={'check'} /> {percentageCompleted}% Complete
              </span>
            )}

            {shortDescription && !isLarger && (
              <span className="u-margin-R-xs">{shortDescription}</span>
            )}
          </p>
          {isLarger && description && <p>{description}</p>}
        </Col>
        {isLarger && (
          <Col md={6}>
            <div className={style.illustration}>
              {variant === 'secondary' && <img src={SegmentIllustration} alt="Segment Illustration" />}
              {variant === 'info' && illustrationType[section]}
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default StudyItemCard;
